module.exports = __webpack_public_path__ + "media/public/img/landing_page/headout-2-279df37e8aa9a053a4e2d01d2ed20367.png";